import { Box, Button, Grid, GridItem, VStack } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { FontFamily } from '@common/theming/Fonts';
import currency from '@common/utility/currency';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { useCheckoutSFRViewModel } from '../../../models/CheckoutSFRViewModel';

type AutoSuggestionsProps = {
  onSuggestedAmount: (suggestedAmount: number) => void;
  form: UseFormReturn<{ amount: number }, any>;
};

export const AutoSuggestions: React.FC<AutoSuggestionsProps> = ({ onSuggestedAmount }) => {
  const viewModel = useCheckoutSFRViewModel();
  const { suggestedAmounts, popularAmount } = viewModel.getSuggestedAmounts();

  return (
    <VStack width="full">
      {/* Suggestion Boxes */}
      <Grid width="full" templateColumns={['1fr 1fr', '1fr 1fr', '1fr 1fr', '1fr 1fr 1fr']} gap="20px">
        {suggestedAmounts.map((suggestion, i) => (
          <GridItem key={`suggestion-${i}`} colSpan={1} rowSpan={1}>
            {suggestion === popularAmount ? (
              <Button
                display={'flex'}
                flexDirection={'column'}
                onClick={() => onSuggestedAmount(suggestion)}
                color="black"
                height={['60px', '60px', '60px', '80px']}
                backgroundColor={suggestion === viewModel.amount ? 'blue.50' : 'gray.50'}
                border='2px'
                borderColor={suggestion === viewModel.amount ? 'blue.100' : 'gray.50'}
                position="relative"
                _hover={{ backgroundColor: ['blue.50'] }}
                width="full">
                <Box
                  display={'flex'}
                  alignItems={'center'}
                  background="linear-gradient(269.95deg, #308EFF 0.04%, #034089 150.42%)"
                  borderRadius={['10px', '5px']}
                  color="white"
                  fontSize="12px"
                  lineHeight="22px"
                  justifyContent={'center'}
                  marginRight={['10px', '10px', '10px', '0']}
                  paddingX="10px"
                  position={['absolute']}
                  right={['-12px', '0px', '0px', 'auto']}
                  top={['-5px', '-11px', '-11px', '-11px']}
                  height={['22px', '22px', '22px', '22px']}
                  width={['22px', 'auto', 'auto', 'auto']}>
                  <TextBlock
                    color="white"
                    fontSize={'12px'}
                    weight="bold"
                    display={['none', 'inline', 'inline', 'inline']}>
                    Popular
                  </TextBlock>
                  <Icon display={['block', 'none', 'none', 'none']} icon="star" color={'white'} boxSize="10px" />
                </Box>
                <Box
                  fontFamily={FontFamily.HELVETICA_NOW_BOLD}
                  fontWeight="normal"
                  background="linear-gradient(270deg, #308EFF 0%, #034089 100%)"
                  backgroundClip="text">
                  {currency.format(suggestion, { maximumFractionDigits: 0 })}
                </Box>
                {viewModel.property?.share_price && (
                  <TextBlock fontSize="16px" color="gray.400">
                    {suggestion / Number(viewModel.property?.share_price ?? 0)} shares
                  </TextBlock>
                )}
              </Button>
            ) : (
              <Button
                display={'flex'}
                flexDirection={'column'}
                onClick={() => onSuggestedAmount(suggestion)}
                color="black"
                height={['60px', '60px', '60px', '80px']}
                backgroundColor={suggestion === viewModel.amount ? 'blue.50' : 'gray.50'}
                border='2px'
                borderColor={suggestion === viewModel.amount ? 'blue.100' : 'gray.50'}
                _hover={{ backgroundColor: 'blue.50', borderColor: 'blue.100' }}
                width="full">
                <TextBlock weight="bold">{currency.format(suggestion, { maximumFractionDigits: 0 })}</TextBlock>
                {viewModel.property?.share_price && (
                  <TextBlock fontSize="16px" color="gray.400">
                    {suggestion / Number(viewModel.property?.share_price ?? 0)} shares
                  </TextBlock>
                )}
              </Button>
            )}
          </GridItem>
        ))}
      </Grid>
    </VStack>
  );
};
